import { Box, Flex, Heading } from '@chakra-ui/react'
import CostSheetPDFFunctionCard from '../../components/CostSheetPDFFunctionCard'
import SignCommercialProposalCard from '../../components/SignCommercialProposalCard'
import SignCostSheetCard from '../../components/SignCostSheetCard'
import SendQuotationCompletedEmailCard from './SendQuotationCompletedEmailCard'

const AdminEmailFunctionPage = () => {
  return (
    <Box shadow="md" borderWidth="1px" bg="white" w="100%" mb="300px" p="5">
      <Flex p={5} mb="3">
        <Heading> Admin Email Function </Heading>
      </Flex>
      <Flex direction="column" gap="3"></Flex>
      <SendQuotationCompletedEmailCard />
    </Box>
  )
}

export default AdminEmailFunctionPage
